import Vue from 'vue';
import batchIngredienceTransformer from '../../transformers/batchIngredience';
import store from './../../store';

const success = (resolve, response) => {
  store.dispatch('addBatchIngredience', batchIngredienceTransformer.fetch(response.data));
  resolve();
};

const failed = (errors, reject) => {
  reject(batchIngredienceTransformer.fetch(errors));
};

export default batchIngredience => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/production/batch_ingredience', batchIngredienceTransformer.send(batchIngredience))
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batchIngredience/store.js